(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["td-product-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('td-product-showcase-tabs')) {
	class TDProductShowcaseTabs extends HTMLElement {
		constructor() {
			super();

			this.mobileTabs = this.querySelectorAll('.td-product-showcase__mobile-tab');
      this.allCards = this.querySelectorAll('td-product-showcase-card');
		}

		connectedCallback() {
			this.mobileTabs.forEach(tab => {
				tab.addEventListener('click', (e) => {
					e.preventDefault();
					const blockId = tab.dataset.blockId;
					if (blockId) {
						this.activateTab(blockId);
					}
				});
			});
		}

		activateTab(blockId) {
			this.mobileTabs.forEach(tab => {
				const isActive = tab.dataset.blockId === blockId;
				tab.classList.toggle('active', isActive);
			});

			const targetCard = this.querySelector(`td-product-showcase-card[data-block-id="${blockId}"]`);
			if (targetCard) {
				targetCard.classList.remove('td-hide-card');
				if (targetCard.activateCard) {
					targetCard.activateCard();
				}
			}

			this.allCards.forEach(card => {
				if (card.dataset.blockId !== blockId) {
					card.classList.add('td-hide-card');
				}
			});
		}
	}

	customElements.define('td-product-showcase-tabs', TDProductShowcaseTabs);
}

if (!customElements.get('td-product-showcase-card')) {
	class TDProductShowcaseCard extends HTMLElement {
		constructor() {
			super();

			this.card = this.querySelector('.td-product-showcase__card');
			this.variantRadios = this.card?.querySelectorAll('.td-product-showcase__variant-radio') || [];
			this.addToCartButton = this.card?.querySelector('.td-product-showcase__add-to-cart');
			
			// Find all cards in the same container
			const cardsContainer = this.closest('.td-product-showcase__cards');
			this.allCards = cardsContainer ? cardsContainer.querySelectorAll('.td-product-showcase__card') : [];
			
			this.selectedProductId = null;
			this.selectedVariantId = null;
			this.selectedVariantPrice = null;
			this.isLoading = false;
		}

		connectedCallback() {
			if (this.card && this.addToCartButton) {

				this.originalButtonText = this.addToCartButton.textContent.trim();
				this.setUpFirstVariant();
				this.setupEventListeners();
				this.updateButtonText();
			}
		}

		setUpFirstVariant() {
			const firstCheckedRadio = Array.from(this.variantRadios).find(radio => radio.checked) || this.variantRadios[0];
			
			if (firstCheckedRadio) {
				// Multi-variant product
				this.selectedProductId = this.addToCartButton?.dataset.productId || null;
				this.selectedVariantId = firstCheckedRadio.dataset.variantId || firstCheckedRadio.value;
				this.selectedVariantPrice = firstCheckedRadio.dataset.variantPrice || null;
				
				if (this.selectedVariantPrice) {
					this.updateButtonPrice(this.selectedVariantPrice);
				}
				
				if (this.addToCartButton && this.selectedVariantId) {
					this.addToCartButton.dataset.variantId = this.selectedVariantId;
				}
			} else if (this.addToCartButton) {
				// Single-variant product\
				this.selectedProductId = this.addToCartButton.dataset.productId || null;
				this.selectedVariantId = this.addToCartButton.dataset.variantId || null;
			}
		}

		setupEventListeners() {
			this.variantRadios.forEach((radio) => {
				radio.addEventListener('change', () => {
					if (radio.checked) {
						this.handleVariantChange(radio);
					}
				});
			});

			if (this.addToCartButton) {
				this.addToCartButton.addEventListener('click', (e) => {
					if (!this.isCardActive()) {
						e.preventDefault();
						e.stopPropagation();
						this.activateCard();
						return;
					}
					
					e.preventDefault();
					e.stopPropagation();
					this.handleAddToCart();
				});
			}
		}

		isCardActive() {
			return this.card?.classList.contains('active') || false;
		}

		activateCard() {
			if (!this.card) return;
			
			this.card.classList.add('active');
			this.allCards.forEach(card => {
				if (card !== this.card) {
					card.classList.remove('active');

					const cardComponent = card.closest('td-product-showcase-card');
					if (cardComponent && cardComponent.updateButtonText) {
						cardComponent.updateButtonText();
					}
				}
			});
			
			// Update button text for activated card
			this.updateButtonText();
		}
		
		updateButtonText() {
			if (!this.addToCartButton) return;
			
			if (this.isCardActive()) {
				if (this.selectedVariantPrice) {
					this.updateButtonPrice(this.selectedVariantPrice);
				} else if (this.originalButtonText) {
					this.addToCartButton.textContent = this.originalButtonText;
				}
			} else {
				this.addToCartButton.textContent = 'SELECT MODEL';
			}
		}

		handleVariantChange(radio) {
			const variantId = radio.dataset.variantId || radio.value;
			const variantPrice = radio.dataset.variantPrice;

			if (!variantId) {
				console.error('TDProductShowcaseCard: Missing variant ID', radio);
				return;
			}

			this.selectedVariantId = variantId;
			this.selectedVariantPrice = variantPrice;

			// Update button
			if (this.addToCartButton) {
				this.addToCartButton.dataset.variantId = variantId;
				
				// Update price
				if (this.selectedVariantPrice) {
					this.updateButtonPrice(this.selectedVariantPrice);
				}

				// Check if variant is available
				const isAvailable = !radio.disabled && !radio.classList.contains('disabled');
				this.addToCartButton.disabled = !isAvailable;
				
				if (!isAvailable) {
					this.addToCartButton.textContent = 'SOLD OUT';
				}
			}
		}

		updateButtonPrice(price) {
			if (!this.addToCartButton || !price) return;
			
			// Only update price if card is active
			if (!this.isCardActive()) {
				return;
			}
			
			const priceFormatted = this.formatMoney(parseInt(price));
			this.addToCartButton.innerHTML = `ADD TO CART  <span class="td-product-showcase__add-to-cart-price">|  ${priceFormatted}</span>`;
		}

		formatMoney(cents) {
			if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
				return window.Shopify.formatMoney(cents);
			}
			// Fallback formatting
			return '$' + (cents / 100).toFixed(2);
		}

		async handleAddToCart() {
			if (this.isLoading || !this.selectedVariantId) {
				return;
			}

			this.setLoadingState(true);

			try {
				const cartUrl = window.Shopify?.routes?.root 
					? `${window.Shopify.routes.root}cart/add.js`
					: '/cart/add.js';

				const response = await fetch(cartUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json'
					},
					body: JSON.stringify({
						items: [{
							id: parseInt(this.selectedVariantId),
							quantity: 1
						}]
					})
				});

				if (response.status === 200) {
					const result = await response.json();
					document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: result }));
					this.showSuccessState();
				} else {
					const errorData = await response.json();
					this.showErrorState(errorData.description || 'Failed to add item to cart.');
				}
			} catch (error) {
				console.error('TDProductShowcaseCard: Cart add error', error);
				this.showErrorState('Network error. Please try again.');
			} finally {
				setTimeout(() => {
					this.setLoadingState(false);
				}, 1500);
			}
		}

		setLoadingState(loading) {
			this.isLoading = loading;
			if (!this.addToCartButton) return;
			
			if (loading) {
				this.showLoadingState();
			} else {
				this.restoreButtonState();
			}
		}

		showLoadingState() {
			const currentText = this.addToCartButton.textContent;
			this.addToCartButton.dataset.originalText = currentText;
			
			this.addToCartButton.disabled = true;
			this.addToCartButton.classList.add('loading');
			this.addToCartButton.textContent = 'ADDING...';
		}

		showSuccessState() {
			if (!this.addToCartButton) return;
			this.addToCartButton.textContent = 'ADDED!';
		}

		restoreButtonState() {
			if (!this.addToCartButton) return;
			
			this.addToCartButton.disabled = false;
			this.addToCartButton.classList.remove('loading');
			this.updateButtonText();
		}

		showErrorState(message) {
			if (!this.addToCartButton) return;
			
      console.error(message);
			const errorMessage = `ERROR - TRY AGAIN`;
			this.addToCartButton.textContent = errorMessage;
			
			setTimeout(() => {
				this.restoreButtonState();
			}, 2000);
		}
	}

	customElements.define('td-product-showcase-card', TDProductShowcaseCard);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-storytelling-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('td-storytelling-products')) {
	class TDStorytellingProducts extends HTMLElement {
		constructor() {
			super();

			this.radios = this.querySelectorAll('.td-storytelling-products__tab-radio');
			this.tabContents = this.querySelectorAll('.td-storytelling-products__tab-content');
			this.tabButtons = this.querySelectorAll('.td-storytelling-products__tab-button');
		}

		connectedCallback() {
			if (this.radios.length && this.tabContents.length) {
				this.setupEventListeners();

        // Show initial tab
        const checkedRadio = Array.from(this.radios).find(radio => radio.checked) || this.radios[0];
        this.updateTab(checkedRadio);
			}
		}

		setupEventListeners() {
			this.radios.forEach((radio) => {
				radio.addEventListener('change', () => {
          this.updateTab(radio);
				});
			});
		}

    updateTab(checkedRadio) {
      if (checkedRadio) {
        const tabId = checkedRadio.getAttribute('aria-controls');
        if (tabId) {
          this.showTabById(tabId);
        }
      }
    }

		showTabById(tabId) {
      // Get target tab
			const targetTab = Array.from(this.tabContents).find(content => content.id === tabId);
			if (!targetTab) {
				console.error('TDStorytellingProducts: Tab not found', tabId);
				return;
			}

			// Show targeted tab, hide others
			this.tabContents.forEach((content) => {
				if (content.id === tabId) {
					content.classList.add('active');
					content.setAttribute('aria-hidden', 'false');
				} else {
					content.classList.remove('active');
					content.setAttribute('aria-hidden', 'true');
				}
			});

			// Update ARIA attributes
			this.tabButtons.forEach((button) => {
				const buttonFor = button.getAttribute('for');
				const correspondingRadio = this.querySelector(`#${buttonFor}`);
				if (correspondingRadio) {
					const radioTabId = correspondingRadio.getAttribute('aria-controls');
					if (radioTabId === tabId) {
						button.setAttribute('aria-selected', 'true');
						button.classList.add('active');
					} else {
						button.setAttribute('aria-selected', 'false');
						button.classList.remove('active');
					}
				}
			});
		}
	}

	customElements.define('td-storytelling-products', TDStorytellingProducts);
}

if (!customElements.get('td-storytelling-category-manager')) {
	class TDStorytellingCategoryManager extends HTMLElement {
		constructor() {
			super();

			this.productRadios = this.querySelectorAll('.td-storytelling-products__content-selector-radio');
			this.variantButtons = this.querySelectorAll('.td-storytelling-products__content-selector-variant');
			this.galleryContainer = this.querySelector('[data-product-gallery-container]');
			this.addToCartButton = this.querySelector('.td-storytelling-products__content-add-to-cart');
			this.priceSpan = this.querySelector('.td-storytelling-products__content-add-to-cart-price');
			this.storeAvailabilityContainer = this.querySelector('.td-storytelling-products__store-availability');
			
			this.selectedProductId = null;
			this.selectedProductHandle = null;
			this.selectedVariantId = null;
			this.selectedProductName = null;
			this.isLoading = false;
			this.storeAvailability = null;
			this.gallerySectionId = this.galleryContainer ? this.galleryContainer.dataset.gallerySectionId : null;
		}

		connectedCallback() {
			if (this.productRadios.length && this.addToCartButton) {
				this.setUpFirstProduct();
				this.setupEventListeners();
			}
		}

		setUpFirstProduct() {
			const firstCheckedRadio = Array.from(this.productRadios).find(radio => radio.checked) || this.productRadios[0];
			
			if (firstCheckedRadio) {
				this.selectedProductId = firstCheckedRadio.dataset.productId;
				this.selectedVariantId = firstCheckedRadio.value || firstCheckedRadio.dataset.variantId;
				this.selectedPrice = firstCheckedRadio.dataset.variantPrice || firstCheckedRadio.dataset.productPrice || null
				this.selectedProductName = firstCheckedRadio.dataset.productName || '';
				this.selectedProductHandle = firstCheckedRadio.dataset.productHandle || this.galleryContainer?.dataset.productHandle;
				
				if (this.selectedPrice) {
					this.updatePrice(this.selectedPrice);
				}
				
				this.initializeStoreAvailability();
				
				// Update gallery container data attribute
				if (this.galleryContainer) {
					this.galleryContainer.dataset.productId = this.selectedProductId;
					if (this.selectedProductHandle) {
						this.galleryContainer.dataset.productHandle = this.selectedProductHandle;
					}
				}
			}
		}

		setupEventListeners() {
			// Listen for product selector radio changes
			this.productRadios.forEach((radio) => {
				radio.addEventListener('change', () => {
					if (radio.checked) {
						this.handleProductChange(radio);
					}
				});
			});

			// Listen for variant button clicks
			this.variantButtons.forEach((button) => {
				button.addEventListener('click', () => {
					this.handleVariantChange(button);
				});
			});

			// Listen for add to cart button click
			if (this.addToCartButton) {
				this.addToCartButton.addEventListener('click', () => {
					this.handleAddToCart();
				});
			}
		}

		async handleProductChange(radio) {
			this.selectedProductId = radio.dataset.productId;
			this.selectedVariantId = radio.value || radio.dataset.variantId;
			this.selectedPrice = radio.dataset.variantPrice || radio.dataset.productPrice || null;
			this.selectedProductName = radio.dataset.productName || '';
			
			// Get product handle from radio or find it
			const productHandle = radio.dataset.productHandle || this.getProductHandleFromId(this.selectedProductId);
			this.selectedProductHandle = productHandle;
			
			this.updateVariantButtonsForProduct(radio);
			
			if (this.selectedPrice) {
				this.updatePrice(this.selectedPrice);
			}
			
			this.updateStoreAvailability();
			
			// Update gallery via section rendering API
			if (productHandle) {
				await this.updateProductGallery(productHandle);
			}
		}

    // Backup method to get product handle from gallery container
		getProductHandleFromId(productId) {
			if (this.galleryContainer) {
				return this.galleryContainer.dataset.productHandle;
			}
			return null;
		}

    updateVariantButtonsForProduct(radio) {
      const selectorContainer = radio.closest('.td-storytelling-products__content-selector');
      if (!selectorContainer) return;
      
      // Show variant buttons for selected product
      const variantsContainer = selectorContainer.querySelector('.td-storytelling-products__content-selector-variants');
      if (!variantsContainer) return;
      
      const firstVariant = variantsContainer.querySelector('.td-storytelling-products__content-selector-variant[data-selected="true"]') || 
                           variantsContainer.querySelector('.td-storytelling-products__content-selector-variant');
      
      if (firstVariant) {
        const firstVariantId = firstVariant.dataset.variantId;
        const firstVariantPrice = firstVariant.dataset.variantPrice || radio.dataset.productPrice;
        
        if (firstVariantId) {
          this.selectedVariantId = firstVariantId;
          this.selectedPrice = firstVariantPrice;
        }
      }
    }

		handleVariantChange(button) {
			const variantId = button.dataset.variantId;
			const variantPrice = button.dataset.variantPrice;
      let selectorContainer = button.closest('.td-storytelling-products__content-selector');
			const radio = selectorContainer ? selectorContainer.querySelector('.td-storytelling-products__content-selector-radio') : null;
			const productPrice = radio ? radio.dataset.productPrice : null;

			if (!variantId) {
				console.error('TDStorytellingCategoryManager: Missing variant ID', button);
				return;
			}

			this.selectedVariantId = variantId;
			this.selectedPrice = variantPrice || productPrice;

			// Update price
			if (this.selectedPrice) {
				this.updatePrice(this.selectedPrice);
			}
			
			this.updateStoreAvailability();

			// Update variant button selected states
			const variantsContainer = button.closest('.td-storytelling-products__content-selector-variants');
			if (variantsContainer) {
				variantsContainer.querySelectorAll('.td-storytelling-products__content-selector-variant').forEach(btn => {
					btn.classList.remove('selected');
					btn.removeAttribute('data-selected');
				});
				button.classList.add('selected');
				button.setAttribute('data-selected', 'true');
			}

			// Update the radio button value to match selected variant
			selectorContainer = button.closest('.td-storytelling-products__content-selector');
			if (selectorContainer) {
				const radio = selectorContainer.querySelector('.td-storytelling-products__content-selector-radio');
				if (radio && radio.checked) {
					radio.value = variantId;
					radio.dataset.variantId = variantId;
					radio.dataset.variantPrice = variantPrice;
				}
			}
		}

		updatePrice(price) {
			if (this.priceSpan && price) {
        this.priceSpan.textContent = ` | ${this.formatMoney(price)}`;
			}
		}

    formatMoney(cents) {
			if (typeof window.Shopify !== 'undefined' && window.Shopify.formatMoney) {
				return window.Shopify.formatMoney(cents);
			}
			// Fallback formatting
			return '$' + (cents / 100).toFixed(2);
		}

    // This is a workaround to ensure the StoreAvailability is initialized after the page has loaded.
		initializeStoreAvailability() {
			if (!this.storeAvailabilityContainer) return;
			
			const initAvailability = () => {
				if (theme && theme.StoreAvailability && typeof theme.StoreAvailability === 'function') {
					this.storeAvailability = new theme.StoreAvailability(this.storeAvailabilityContainer);
					if (this.selectedVariantId) {
						this.updateStoreAvailability();
					}
				}
			};
			
			// Check if page:loaded already fired
			if (document.readyState === 'complete') {
				setTimeout(initAvailability, 0);
			} else {
				document.addEventListener('page:loaded', initAvailability, { once: true });
			}
		}

		updateStoreAvailability() {
			if (this.storeAvailability && this.selectedVariantId) {
				if (this.selectedProductName && this.storeAvailabilityContainer) {
					this.storeAvailabilityContainer.dataset.productName = this.selectedProductName;
					this.storeAvailability.productTitle = this.selectedProductName;
				}
				// Fetch and render availability for current variant
				this.storeAvailability.updateContent(this.selectedVariantId);
			}
		}

		async handleAddToCart() {
			if (this.isLoading || !this.selectedVariantId) {
				return;
			}

			this.setLoadingState(true);

			try {
				const response = await fetch(`${window.location.origin}/cart/add.js`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json'
					},
					body: JSON.stringify({
						items: [{
							id: parseInt(this.selectedVariantId),
							quantity: 1
						}]
					})
				});

				if (response.status === 200) {
					const result = await response.json();
					document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: result }));
				} else {
					const errorData = await response.json();
					this.showErrorState(errorData.description || 'Failed to add item to cart.');
				}
			} catch (error) {
				console.error('TDStorytellingCategoryManager: Cart add error', error);
				this.showErrorState('Network error. Please try again.');
			} finally {
				this.setLoadingState(false);
			}
		}

    setLoadingState(loading) {
      this.isLoading = loading;
      if (!this.addToCartButton) return;
      
      if (loading) {
        this.showLoadingState();
      } else {
        this.restoreButtonState();
      }
    }
    
    showLoadingState() {
      const currentPrice = this.priceSpan ? this.priceSpan.textContent : '';
      this.addToCartButton.dataset.originalPrice = currentPrice;
      
      this.addToCartButton.disabled = true;
      this.addToCartButton.classList.add('loading');
      const loadingMessage = 'ADDING...';

      this.updateButtonText(null, loadingMessage);
    }
    
    restoreButtonState() {
      const originalPrice = this.addToCartButton.dataset.originalPrice || '$0';
      
      this.addToCartButton.disabled = false;
      this.addToCartButton.classList.remove('loading');
      const defaultMessage = 'ADD TO CART';

      this.updateButtonText(originalPrice, defaultMessage);
    }

		showErrorState(message) {
			const currentPrice = this.priceSpan ? this.priceSpan.textContent : '';
			const buttonText = this.addToCartButton.textContent;
      const errorMessage = `ERROR: ${message}`;
      
      this.updateButtonText(null, errorMessage);
		}

    updateButtonText(currentPrice, message) {
      if (this.priceSpan && currentPrice) {
        this.addToCartButton.innerHTML = `ADD TO CART<span class="td-storytelling-products__content-add-to-cart-price"> | ${currentPrice}</span>`;
        this.priceSpan = this.querySelector('.td-storytelling-products__content-add-to-cart-price');
      } else {
        this.addToCartButton.textContent = message;
      }
    }

		async updateProductGallery(productHandle) {
			if (!this.galleryContainer || !this.gallerySectionId || !productHandle) {
				return;
			}

			try {
        let url = window.Shopify.routes.root + `products/${productHandle}?section_id=${this.gallerySectionId}`;
				const response = await fetch(url);
				
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				
				const html = await response.text();
				const parser = new DOMParser();
				const doc = parser.parseFromString(html, 'text/html');
				const gallerySection = doc.querySelector('[data-product-gallery]');
				
				if (gallerySection) {
					this.galleryContainer.innerHTML = gallerySection.outerHTML;

					this.initializeSwiperSlider();
				}
			} catch (error) {
				console.error('TDStorytellingCategoryManager: Gallery update error', error);
			}
		}

		initializeSwiperSlider() {
			if (customElements.get('swiper-slider')) {
				// Initialize both mobile swiper and thumbnail swiper
				const swiperElements = this.galleryContainer ? 
					this.galleryContainer.querySelectorAll('swiper-slider') : 
					this.querySelectorAll('swiper-slider');
				
				swiperElements.forEach((swiperElement) => {
					if (swiperElement && !swiperElement.initialized) {
						// Trigger initialization
						setTimeout(() => {
							document.dispatchEvent(new Event('shopify:section:load'));
						}, 100);
					}
				});
			}
		}
	}

	customElements.define('td-storytelling-category-manager', TDStorytellingCategoryManager);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get("video-testimonial-card")) {
    class VideoTestimonialCard extends HTMLElement {
      constructor() {
        super();
        this.videoType = this.dataset.videoType || "youtube";
        this.iframeUrl = this.dataset.iframeUrl || "";
        this.shopifyVideoUrl = this.dataset.shopifyVideoUrl || "";
        this.slideInner = this.querySelector(".td-video-testimonials__slide-inner");
        this.modal = null;
        this.modalIframe = null;
        this.modalVideo = null;
      }
  
      connectedCallback() {
        if (this.videoType === "shopify" && !this.shopifyVideoUrl) {
          console.warn("VideoTestimonialCard: No Shopify video URL provided");
          return;
        }
        if (this.videoType !== "shopify" && !this.iframeUrl) {
          console.warn("VideoTestimonialCard: No iframe URL provided");
          return;
        }
  
        const section = this.closest(".td-video-testimonials");
        if (section) {
          this.modal = section.querySelector(".td-video-testimonials__modal");
          if (this.modal) {
            this.modalIframe = this.modal.querySelector(".td-video-testimonials__modal-iframe");
            this.modalVideo = this.modal.querySelector(".td-video-testimonials__modal-video-element");
          }
        }
  
        if (!this.modal) {
          console.warn("VideoTestimonialCard: Modal not found");
          return;
        }
  
        if (this.videoType === "shopify" && !this.modalVideo) {
          console.warn("VideoTestimonialCard: Modal video element not found");
          return;
        }
        if (this.videoType !== "shopify" && !this.modalIframe) {
          console.warn("VideoTestimonialCard: Modal iframe not found");
          return;
        }
  
        this.attachEventListeners();
      }
  
      attachEventListeners() {
        if (this.slideInner) {
          this.slideInner.addEventListener("click", this.handleClick.bind(this));
        }
  
        const closeButton = this.modal.querySelector(".td-video-testimonials__modal-close");
        if (closeButton) {
          closeButton.addEventListener("click", this.closeModal.bind(this));
        }
  
        const overlay = this.modal.querySelector(".td-video-testimonials__modal-overlay");
        if (overlay) {
          overlay.addEventListener("click", this.closeModal.bind(this));
        }
      }
  
      handleClick() {
        this.openModal();
      }
  
      openModal() {
        if (!this.modal) return;
  
        if (this.videoType === "shopify") {
          if (!this.modalVideo) return;
          this.modalIframe.style.display = "none";
          this.modalVideo.style.display = "block";
          this.modalVideo.src = this.shopifyVideoUrl;
          this.modalVideo.load();
          this.modalVideo.play();
        } else {
          if (!this.modalIframe) return;
          this.modalVideo.style.display = "none";
          this.modalIframe.style.display = "block";
          this.modalIframe.src = this.iframeUrl;
        }
  
        this.modal.classList.remove("td-video-testimonials__modal--hidden");
        this.modal.setAttribute("aria-hidden", "false");
  
        const closeButton = this.modal.querySelector(".td-video-testimonials__modal-close");
        if (closeButton) {
          closeButton.focus();
        }
  
        document.body.style.overflow = "hidden";
      }
  
      closeModal() {
        if (!this.modal) return;
  
        if (this.modalIframe) {
          this.modalIframe.src = "";
        }
        if (this.modalVideo) {
          this.modalVideo.pause();
          this.modalVideo.src = "";
        }
  
        this.modal.classList.add("td-video-testimonials__modal--hidden");
        this.modal.setAttribute("aria-hidden", "true");
  
        document.body.style.overflow = "";
  
        if (this.slideInner) {
          this.slideInner.focus();
        }
      }
    }
  
    customElements.define("video-testimonial-card", VideoTestimonialCard);
  }

  } catch(e) { console.error(e); }
})();
})();
